import { CurrencyDollarSimple } from '@phosphor-icons/react';

export default CurrencyDollarSimple;
